document.addEventListener('DOMContentLoaded', () => {
  const inDesignMode = Boolean(window.Shopify && window.Shopify.designMode);
  let revealObserver = null;

  const activateRevealNodes = (root = document) => {
    const nodes = root.querySelectorAll ? root.querySelectorAll('[data-reveal]') : [];

    if (inDesignMode) {
      nodes.forEach((node) => node.classList.add('is-visible'));
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) entry.target.classList.add('is-visible');
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
    }

    nodes.forEach((node) => revealObserver.observe(node));
  };

  const nav = document.querySelector('[data-site-header]');
  const setScrolled = () => {
    if (nav) nav.classList.toggle('scrolled', window.scrollY > 20);
  };
  setScrolled();
  window.addEventListener('scroll', setScrolled);

  activateRevealNodes();

  if (inDesignMode) {
    document.addEventListener('shopify:section:load', (event) => activateRevealNodes(event.target));
    document.addEventListener('shopify:block:select', (event) => activateRevealNodes(event.target));
  }

  document.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  document.querySelectorAll('[data-blog-filter]').forEach((button) => {
    button.addEventListener('click', () => {
      const group = button.closest('[data-blog-filters]');
      const wrapper = document.querySelector('[data-blog-grid]');
      if (!group || !wrapper) return;
      group.querySelectorAll('[data-blog-filter]').forEach((node) => node.classList.remove('active'));
      button.classList.add('active');
      const tag = button.dataset.blogFilter;
      wrapper.querySelectorAll('[data-article-card]').forEach((card) => {
        const tags = (card.dataset.tags || '').split('|');
        const visible = tag === 'all' || tags.includes(tag);
        card.style.display = visible ? 'flex' : 'none';
      });
    });
  });

  const search = document.querySelector('[data-blog-search]');
  if (search) {
    search.addEventListener('input', () => {
      const query = search.value.trim().toLowerCase();
      document.querySelectorAll('[data-article-card]').forEach((card) => {
        const visible = card.textContent.toLowerCase().includes(query);
        card.style.display = visible ? 'flex' : 'none';
      });
    });
  }

  const mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', () => {
      const expanded = mobileToggle.getAttribute('aria-expanded') === 'true';
      mobileToggle.setAttribute('aria-expanded', String(!expanded));
      mobileNav.hidden = expanded;
    });

    mobileNav.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        mobileToggle.setAttribute('aria-expanded', 'false');
        mobileNav.hidden = true;
      });
    });
  }

  document.querySelectorAll('[data-contact-lead-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (form.dataset.leadMirrorComplete === 'true') return;

      const apiUrl = form.dataset.contactApiUrl;
      if (!apiUrl) return;

      event.preventDefault();

      const formData = new FormData(form);
      const submitButton = form.querySelector('button[type="submit"]');
      const originalLabel = submitButton ? submitButton.textContent : '';

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Submitting...';
      }

      const payload = {
        source: form.dataset.contactSource || 'shopify_storefront',
        shop_domain: window.location.hostname,
        page_url: window.location.href,
        page_title: document.title,
        name: formData.get('contact[name]') || '',
        email: formData.get('contact[email]') || '',
        phone: formData.get('contact[phone]') || '',
        monthly_orders: formData.get('contact[monthly_orders]') || '',
        need: formData.get('contact[need]') || '',
        message: formData.get('contact[body]') || '',
        referrer: document.referrer || '',
        user_agent: window.navigator.userAgent,
        payload: {
          source_page: formData.get('contact[source_page]') || '',
          source_page_title: formData.get('contact[source_page_title]') || '',
        },
      };

      try {
        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), 3500);

        await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
          signal: controller.signal,
          keepalive: true,
        });

        window.clearTimeout(timeoutId);
      } catch (error) {
        console.warn('Lead mirror request failed, continuing with Shopify contact submit.', error);
      } finally {
        form.dataset.leadMirrorComplete = 'true';
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalLabel;
        }
        form.submit();
      }
    });
  });
});
